import {faTableCells} from "@fortawesome/free-solid-svg-icons";

export default faTableCells;
